import { useRef } from "react";
import styled from "styled-components";
import SizedBox from "./SizedBox";

const Wrapper = styled.div`
  font-family: "Roboto Condensed";
  margin: 0;
  padding: 0;
  background-color: rgb(252, 245, 243);
  background-image: url(data:image/png;base64,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);
  background-position: 0% 0%;
  height: 100vh;
  max-height: 100vh;
  width: fit-content;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  // scroll-behavior: smooth;
`;

const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  padding-left: 150px;
`;

const LeftColumn = styled.div`
  min-width: 300px;
  width: 300px;
  margin-right: 100px;
`;

const LeftColumnTitle = styled.p`
  color: rgba(0, 0, 0, 0.7);
  font-size: 32px;
  text-transform: capitalize;
  position: relative;
  width: fit-content;
  font-weight: bold;

  &:after {
    content: "";
    position: absolute;
    height: 2px;
    background: rgba(0, 0, 0, 0.7);
    bottom: 2px;
    left: 0;
    right: 0;
  }
`;

const LeftColumnParagraph = styled.p`
  font-weight: 300;
  line-height: 1.5;
  font-size: 18px;
`;

const BigTitle = styled.p`
  color: rgba(0, 0, 0, 0.7);
  font-size: 480px;
  text-transform: uppercase;
  letter-spacing: -15px;
  font-weight: bold;
  margin: 0;
`;

const StoriesWrapper = styled.div`
  background-color: rgb(32, 32, 32);
  margin-top: -200px;
  /* padding-top: 200px; */
`;

const StoriesWrapperTitle = styled.p`
  color: white;
  font-size: 72px;
  text-transform: uppercase;
  font-weight: bold;
`;

const StoriesTitleContainer = styled.div`
  height: 200px;
  padding-left: 50px;
`;

const StoriesContainer = styled.div`
  background-color: rgb(252, 245, 243);
  height: 100%;
  width: 100%;
  display: flex;
  gap: 50px;
  padding: 50px 50px 250px 50px;
  margin-left: -250px;
`;

const Story = styled.div`
  width: 550px;
  height: 400px;
  background-color: rgba(0, 0, 0, 0.8);
`;

const HorizontalStories = ({ title = "liefde" }) => {
  const scrollEl = useRef(null);

  const onScrollWheel = (event) => {
    if (scrollEl.current) {
      scrollEl.current.scrollLeft += event.deltaY;
    }
  };

  return (
    <Wrapper onWheel={onScrollWheel} ref={scrollEl}>
      <SizedBox height="200px" />
      <Flex>
        <LeftColumn>
          <LeftColumnTitle>{title}</LeftColumnTitle>
          <LeftColumnParagraph>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi
            corrupti incidunt doloremque officiis. Ducimus hic eligendi
            cupiditate sed. Maiores suscipit eveniet incidunt molestiae est
            impedit labore aperiam error vitae non accusamus voluptas quod culpa
            doloribus in deserunt tempora, qui consectetur necessitatibus
            consequuntur itaque similique quaerat quasi! Commodi ipsa numquam
            vero quas. Sequi, officia. Voluptas alias consequatur eveniet vero
            veniam molestias?
          </LeftColumnParagraph>
        </LeftColumn>
        <BigTitle>{title}</BigTitle>
        <StoriesWrapper>
          <StoriesTitleContainer>
            <StoriesWrapperTitle>{title}</StoriesWrapperTitle>
          </StoriesTitleContainer>
          <StoriesContainer>
            <Story />
            <Story />
            <Story />
          </StoriesContainer>
        </StoriesWrapper>
      </Flex>
      <SizedBox height="100px" />
    </Wrapper>
  );
};

export default HorizontalStories;
